import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import arrowRight from '~/static/images/icons/arrow_right_white.svg';

import { breakpoints } from '~/src/features/tariffLines/styled';

export const CardWrapper = styled.div<{ bgColor?: string, withCellSpacing: boolean }>`
    display: flex;
    cursor: pointer;
    justify-content: space-around;
    position: relative;
    flex-wrap: nowrap;
    flex-direction: column;
    padding: 8px 8px 16px 8px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background: ${({ bgColor }) => bgColor || COLORS.BgSurface};
    width: 380px;
    min-height: 253px;
    transition: box-shadow .3s;
    ${({ withCellSpacing }) => withCellSpacing && css`
        margin-right: 24px;
        margin-bottom: 24px;
        
        @media (max-width: 480px) {
          margin-right: 12px;
        }
    `};
  
    @media (max-width: ${breakpoints.tablet}) {
        max-width: 360px;
        margin-right: 16px;
    }
    
    @media (max-width: ${breakpoints.mobile}) {
        max-width: 304px;
    }
    
    :hover {
        box-shadow: 0 12px 24px rgba(26, 26, 26, 0.06);
    }
`;

export const ImageBlock = styled(LazyLoadImage)<{ src: string }>`
    width: 100%;
    background-size: cover;
    margin-bottom: 24px;
    border-radius: ${BorderRadius.InnerBlockRadius};
`;

export const Bottom = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
`;

export const Text = styled.div`
    ${FONTS.H4};
    padding-left: 16px;
    max-width: 250px;
    @media (max-width: ${breakpoints.mobile}) {
        max-width: 240px;
    }
`;

export const Button = styled.div`
    position: relative;
    height: 40px;
    width: 40px;
    right: 16px;
    cursor: pointer;
    background-image: url('${arrowRight}');
`;

export const Header = styled.div`
    position: absolute;
    top: 26px;
    left: 34px;
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    padding: 4px 12px;
    border-radius: ${BorderRadius.labelRadius};
`;
